import React, { forwardRef } from 'react';

import { useTheme } from 'hooks';

import { Check, CheckRoot } from './Check.styles';

export type CheckProps = {
  id?: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  checked?: boolean;
  defaultChecked?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  color?: 'primary' | 'secondary';
} & React.HTMLAttributes<HTMLElement>;

const CheckBase = forwardRef<HTMLInputElement, CheckProps>(
  (
    {
      id,
      disabled: disabledProp,
      readOnly,
      required,
      checked,
      defaultChecked,
      name,
      onChange: onChangeProp,
      value,
      inputProps = {},
      color = 'primary',
      ...props
    },
    ref,
  ) => {
    const { theme } = useTheme();
    const { palette } = theme;

    const disabled = disabledProp || readOnly;

    const CheckRootStyles: object = {
      '--color': disabledProp ? palette.grey : palette[color],
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (disabled) return;
      if (onChangeProp) onChangeProp(e);
    };

    const CheckProps = {
      ...inputProps,
      id,
      type: 'checkbox',
      name,
      value,
      defaultChecked,
      checked,
      disabled,
      readOnly,
      onChange,
      required,
      ref,
    };

    const CheckRootProps = {
      ...props,
      style: {
        ...props.style,
        ...CheckRootStyles,
      },
      disabled,
    };

    return (
      <CheckRoot {...CheckRootProps}>
        <Check {...CheckProps} />
      </CheckRoot>
    );
  },
);

export default CheckBase;
